<template>

    <form v-on:submit.prevent="executeLoadGrid(filter)" ref="certificacoespoliticapreco-form-vincularsessao" novalidate>
        <div class="row" v-if="exibirFiltros">
            <div class="form-group col-md-8">
                <label for="Exame">Seleciona abaixo a sessão que deseja vincular a esta política comercial:</label>
                <select v-select="{ dataitem: 'CertificacoesSessao', default: 'Selecione', filters: { attributeBehavior: 'getCertificacoes', certificacoesPoliticaPrecoId: id }}" v-model="model.certificacoesSessaoId" class="form-control" id="certificacoesSessaoId" name="certificacoesSessaoId"></select>
            </div>
            <div class="form-group col-md-4 mt-4">
                <br />
                <button class="form-group btn-large-30 btn-lg btn-success" @click="vincular()">
                    Vincular
                </button>
            </div>

        </div>
        <h5>Sessões já Vinculadas:</h5>
        <br />

        <div class="row">

            <div class="form-group col-md-2">
                <label for="id">Id</label>
                <input type="text" class="form-control" name="id" placeholder="Id" v-model="filter.certificacoesSessaoId" />
            </div>
            <div class="form-group col-md-4">
                <label for="Exame">Exame</label>
                <select v-select="{ dataitem: 'Interesse', default: 'Todos' }" v-model="filter.interesseId" class="form-control" id="exameId" name="exameId"></select>
            </div>
            <div class="form-group col-md-4">
                <label for="sessaoVinculada">Nome Sessão</label>
                <select v-select="{ dataitem: 'CertificacoesSessao', default: 'Todos', filters: { certificacoesPoliticaPrecoId: this.id}}" v-model="filter.certificacoesSessaoId" class="form-control" name="sessaoid"></select>
            </div>
            <div class="form-inline">
                <button type="button" class="btn-large-40 btn-red uppercase mt-3 " @click="executeLoadGrid(filter)">Buscar</button>
            </div>

        </div>
        <br />
        <div class="row">
            <div class="table-responsive standard-table header-cinza">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>EXAME</th>
                            <th>SESSÃO</th>
                            <th class="text-center"><i class="fa fa-cog md-2"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.itemsForm" class="animated fadeIn">
                            <td>{{ item.certificacoesSessaoId}}</td>
                            <td style="display:none">{{ item.certificacoesSessao ? item.certificacoesSessao.interesseId : ''}}</td>
                            <td>{{ item.certificacoesSessao && item.certificacoesSessao.interesse ? item.certificacoesSessao.interesse.nome : ''}}</td>
                            <td>{{ item.certificacoesSessao ? item.certificacoesSessao.titulo : ''}}</td>
                            <td class="text-center">
                                <button type="button" class="btn btn-sm btn-danger" title="Desfazer vínculo desta sessão com a política comercial" @click="remove(item)">
                                    <i class="fa fa-trash-o"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-block no-padding">
                <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
            </div>
        </div>

        <button type="button" class="btn btn-success float-right" @click="emitEvent()">
            <span>Fechar</span>
        </button>
    </form>
</template>

<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: 'certificacoespoliticapreco-form-vincularsessao',
        mixins: [base],
        props: { id: Number },
        data: () => ({
            houveAlteracao: false,
            idsRemovidos: [],
            ids: '',
            certificacoesSessao: {
                certificacoesPoliticaPrecoId: 0,
                certificacoesSessaoId: 0,
                titulo: null,
                interesseId: 0,
                interesse: {
                    interesseId: 0,
                    nome: null,
                },
            },
            model: {
                certificacoesPoliticaPrecoId: 0,
                collectionCertificacoesPoliticaPrecoSessao: [{
                    certificacoesPoliticaPrecoId: 0, interesse: {
                        interesseId: 0,
                        nome: null,
                    },
                }],
            },
            filter: {
                pageSize: 20,
                pageIndex: 1,
                isPagination: true,
            },
            result: {
                total: 0,
                items: [],
                itemsForm: [],
            },
            exibirFiltros: true,
            form: "certificacoespoliticapreco-form-vincularsessao",
            resources: {
                filterCertificacoesSessao: 'certificacoessessao',
                filterPoliticaPrecoSessao: 'certificacoespoliticaprecosessao',
                filterCertificacoesPoliticaPreco: 'CertificacoesPoliticaPreco',
            },
        }),

        methods: {
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },

            vincular() {
                var sessaoJaAdd = false;

                this.result.itemsForm.filter((sessao) => {
                    if (sessao.certificacoesSessaoId == this.model.certificacoesSessaoId)
                        sessaoJaAdd = true;
                });

                if (!sessaoJaAdd) {
                    this.showLoading();
                    this.exibirFiltros = false;

                    var newModel = {
                        CertificacoesPoliticaPrecoId: this.id,
                        CertificacoesSessaoId: this.model.certificacoesSessaoId,
                        AttributeBehavior: "AdicionarPoliticaPrecoSessaoGridVincular",
                    };
                    new Api(this.resources.filterPoliticaPrecoSessao).post(newModel).then(data => {
                        this.houveAlteracao = true;
                        this.executeLoad();

                        setTimeout(() => { this.exibirFiltros = true; }, 50);
                        this.defaultSuccessResult('Registro inserido com sucesso');
                        this.hideLoading();

                    }, (err) => {
                        this.failLoading();
                        if (err && err.data && err.data.errors) {
                            this.$eventHub.$emit('show-notification', {
                                type: 'error',
                                title: 'Atenção',
                                text: err.data.errors[0]
                            })
                        }
                    });
                } else {
                    this.defaultErrorResult('Este registro já foi inserido.');
                }
            },

            remove(model) {
                this.showLoading();
                this.exibirFiltros = false;
                new Api('CertificacoesPoliticaPrecoSessao/DeleteCertificacoesPoliticaPrecoSessaoVinculado').delete(model).then(data => {
                    this.houveAlteracao = true;
                    setTimeout(() => { this.exibirFiltros = true; }, 50);
                    this.executeLoad();
                    this.defaultSuccessResult('Registro Deletado com sucesso');
                    this.hideLoading();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            emitEvent() {
                if (this.houveAlteracao)
                    this.$emit('on-saved');
                else
                    this.$emit('on-back');
            },

            executeLoadGrid: function (filter) {
                filter.certificacoesPoliticaPrecoId = this.id;
                if (filter) this.filter = filter;
                this.getCertificacoesPoliticaPrecoSessao();
            },

            executeLoad: function () {
                this.getCertificacoesPoliticaPrecoSessao();
            },

            getCertificacoesPoliticaPrecoSessao() {
                this.filter.certificacoesPoliticaPrecoId = this.id;

                this.showLoading();

                new Api(this.resources.filterPoliticaPrecoSessao).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;

                    this.result.itemsForm = data.dataList;

                    this.hideLoading();

                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },
        mounted() {
            this.executeLoad();
        }
    };
</script>
